module.exports = __webpack_public_path__ + "img/banner.3f002b0d.webp";